interface IErrorPayload {
  response: {errors?: Array<string>};
}

const MISSING_TIME_SLOT = 'missingTimeSlot';
const MISSING_REQUEST = 'missingRequest';
const MISSING_LANGUAGE = 'missingLanguage';
const MISSING_TIME_ZONE = 'missingTimeZone';
const NO_MORE_QUESTIONS = 'noMoreQuestions';
const SLOT_NOT_FOUND = 'slotNotFound';
const SLOT_ALREADY_EXISTS = 'slotAlreadyExists';
const SLOT_INFORMATION_IS_MISSING = 'slotInformationIsMissing';
const SLOT_IS_NOT_AVAILABLE_FOR_SCHEDULING = 'slotNotAvailableForScheduling';
const REQUEST_NOT_FOUND = 'requestNotFound';
const REQUEST_ALREADY_EXISTS_IN_SLOT = 'requestAlreadyExistsInSlot';
const REQUEST_INFORMATION_IS_MISSING = 'requestInformationIsMissing';
const REQUEST_NOT_QWNED_BY_USER = 'requestNotOwnedByUser';
const REQUEST_LOCKED = 'lockedRequest';
const OPPORTUNITY_NOT_ASSIGNED = 'opportunityNotAssigned';

export const UNKNOWN = 'unknown';
export const USER_NOT_FOUND = 'userNotFound';
export const COMPANY_NOT_FOUND = 'companyNotFound';
export const USER_INFORMATION_IS_MISSING = 'userInformationIsMissing';
export const WRONG_PASSWORD = 'wrongPassword';
export const PASSWORD_MISMATCH = 'passwordMismatch';
export const EMAIL_MISMATCH = 'emailMismatch';
export const MISSING_FIRST_NAME = 'missingFirstName';
export const MISSING_LAST_NAME = 'missingLastName';
export const MISSING_EMAIL = 'missingEmail';
export const MISSING_PASSWORD = 'missingPassword';
export const INVALID_EMAIL = 'invalidEmail';
export const INVALID_PROVIDER_TOKEN = 'invalidProviderToken';
export const EMAIL_ALREADY_USED = 'emailAlreadyUsed';
export const PLACEMENT_FEEDBACK_NOT_FOUND = 'placementFeedbackNotFound';
export const CONNECTION_REFUSED = 'connectionRefused';
export const USER_ALREADY_ACTIVATED = 'userAlreadyActivated';
export const SESSION_ALREADY_EXISTS = 'sessionAlreadyExists';

/* Job interview scheduling */
export const USER_HAS_INTERVIEW_SCHEDULED = 'userHasInterviewScheduled';
export const INTERVIEW_ALREADY_CONFIRMED = 'interviewAlreadyConfirmed';

export const errorToMessage = (errorName: string) => {
  switch (errorName) {
    // scheduler
    case UNKNOWN: return 'An unexpected error occurred, please try again or contact our support team';
    case MISSING_TIME_SLOT: return 'Please click Cancel button and select a time slot';
    case MISSING_REQUEST: return 'Please select the request you\'d like to cancel';
    case MISSING_LANGUAGE: return 'Please select at least 1 language to interview in';
    case MISSING_TIME_ZONE: return 'Please select your timezone from the list';
    case NO_MORE_QUESTIONS: return `We\'re sorry, but we seem to have run out of new questions for you...
      Please stay tuned, and we\'ll email you as soon as new content is available!`;
    case SLOT_NOT_FOUND: return 'Sorry, but we can\'t seem to find the time slot information';
    case SLOT_ALREADY_EXISTS: return 'There\'s already a time slot configured for that time';
    case SLOT_INFORMATION_IS_MISSING: return 'We need some information to retrieve the time slot';
    case SLOT_IS_NOT_AVAILABLE_FOR_SCHEDULING: return 'Sorry, the slot is no longer available for scheduling, please choose another';
    case REQUEST_NOT_FOUND: return 'Sorry, but we can\'t seem to find your interview request';
    case REQUEST_ALREADY_EXISTS_IN_SLOT: return 'You already have another request scheduled for that time slot';
    case REQUEST_INFORMATION_IS_MISSING: return 'We need some information to retrieve the request';
    case REQUEST_NOT_QWNED_BY_USER: return 'You\'re not the owner of this request, so we can\'t let you cancel it, sorry!';
    case REQUEST_LOCKED: return 'Seems like this request is locked, contact us via email to make changes!';
    // user
    case USER_INFORMATION_IS_MISSING: return 'User info is missing';
    case INVALID_PROVIDER_TOKEN: return 'Invalid token';
    case MISSING_EMAIL: return 'Email is missing';
    case INVALID_EMAIL: return 'Please enter a valid email address';
    case EMAIL_ALREADY_USED: return 'The email you entered is already taken :(';
    case EMAIL_MISMATCH: return 'Please use the invited email';
    case USER_NOT_FOUND:
    case COMPANY_NOT_FOUND: return 'The email or password you entered is incorrect';
    case MISSING_PASSWORD: return 'Password is missing';
    case WRONG_PASSWORD: return 'Password is incorrect';
    case PASSWORD_MISMATCH: return 'Password is mismatched';
    case MISSING_FIRST_NAME: return 'First name is missing';
    case MISSING_LAST_NAME: return 'Last name is missing';
    case CONNECTION_REFUSED: return 'The service seems to be unavailable';
    case PLACEMENT_FEEDBACK_NOT_FOUND: return `
      We're sorry, we're having some issues retrieving the information you're looking for.
      If the problem persists, please contact us at practice@tryexponent.com`;
    case USER_HAS_INTERVIEW_SCHEDULED: return 'You already have an interview at this time';
    case OPPORTUNITY_NOT_ASSIGNED: return 'This job opportunity is no longer available';
    case INTERVIEW_ALREADY_CONFIRMED: return 'You already confirmed this interview';
    case USER_ALREADY_ACTIVATED: return 'User already activated';
    case SESSION_ALREADY_EXISTS: return 'You already have a session in progress with this user';
    default:
      return '';
  }
};

export const getFirstErrorMessage = (apiErrors: Array<string> | string): string  => {
  return [].concat(apiErrors).reduce((result, errorName) => !!result.length ? result : errorToMessage(errorName), '');
};

export const getApiError = ({response}: IErrorPayload) => (
  response && response.errors ? getFirstErrorMessage(response.errors) : UNKNOWN
);
